import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController, IonicSlides } from '@ionic/angular';

@Component({
  selector: 'viso-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css'],
  standalone: false,
})
export class ImageViewerComponent implements OnInit {

  //@ViewChild(IonSlides) slides: IonSlides;
  swiperModules = [IonicSlides];
  @Input('img') images: any;
  @Input('startFrom') startFrom: number;
  @Input('title') title: string;
  @Input('text') text: string;
  @Input() close: Function;
  sliderOpts = {
    zoom: true
  };
  slides: any;
  constructor(
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.slides.update();
    setTimeout(() => {
      this.slides.slideTo(this.startFrom);
    });
  }


}
